import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  icon?: string;
  moreTo?: string;
  moreText?: string;
  children: ReactNode;
}

export default function SectionCard({ title, icon, moreTo, moreText = '查看全部', children }: Props) {
  return (
    <section className="bg-background-50 border border-background-200/80 rounded-lg overflow-hidden">
      <header className="flex items-center justify-between px-4 md:px-5 py-3 border-b border-background-200/80 bg-background-100/60">
        <h2 className="flex items-center gap-2 font-heading font-bold text-base md:text-lg text-foreground-950">
          {icon && (
            <span className="w-6 h-6 flex items-center justify-center text-primary-500">
              <i className={icon}></i>
            </span>
          )}
          {title}
        </h2>
        {moreTo && (
          <Link
            to={moreTo}
            className="flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {moreText}
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        )}
      </header>
      {children}
    </section>
  );
}